import { FunctionComponent } from 'react';
import { CellProps } from 'components/tables/cells';
import VerticalStackCell from './VerticalStackCell';
import { useGlobalContext } from 'components/common/GlobalContext/GlobalContext';
import { Text } from '@montel/montelpro-shared-components-v2';
import { PermissionSet } from 'domain/subscription/interfaces/Subscription';

export interface PlanCellProps extends CellProps {
	permissionSets: Record<string, PermissionSet>;
	applicationId?: string;
}

const AddonsCell: FunctionComponent<PlanCellProps> = ({
	permissionSets,
	applicationId,
	...rest
}) => {
	const { getAddonByCode } = useGlobalContext();

	if (applicationId) {
		const permissionSet = permissionSets[applicationId];
		const addons = permissionSet?.addons || [];

		return (
			<Text size={'sm'}>
				{(addons.length > 0 &&
					addons
						.map(
							(addon) =>
								getAddonByCode(applicationId, addon)?.name,
						)
						.join(', ')) ||
					'-'}
			</Text>
		);
	}

	return <Text size={'sm'}>-</Text>;
};

export default AddonsCell;
